module.exports = __webpack_public_path__ + "media/customizations/everbe/logo-fc681cc7f909aa7ffdd9a31e313edaf1.png";